module.exports = __webpack_public_path__ + "sunsemweb/img/c2.fa6d7eb1.png";